import modules_comeback_reward from './modules_comeback_reward';
import modules_cashout_success from './modules_cashout_success';

export default {
    modules_comeback_reward,
    modules_cashout_success
}